import { cn } from '@jotta/utils/css'
import { Trans } from '@lingui/macro'
import { Link } from 'react-router-dom'

export function BizActionButtonGetMoreStorage({
  className,
  defaultClassName = cn('btn btn-primary'),
}: {
  className?: string
  defaultClassName?: string
}) {
  return (
    <Link
      data-testid="BizActionUpgradeStorage"
      to="/web/upgrade"
      className={cn(className, defaultClassName)}
    >
      <Trans>Get more storage</Trans>
    </Link>
  )
}
